import React from 'react';
import { useSpring, animated, AnimatedProps } from '@react-spring/web';
import { Parallax } from 'react-parallax';

import backgroundImage from '../img/gg_background.jpg';
import ornament from '../img/ornament.png';

const HeroSection: React.FC = () => {
  const titleAnimation = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    delay: 300,
    config: { tension: 40, friction: 30 },
  });
  const subtitleAnimation = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    delay: 1800,
    config: { tension: 40, friction: 30 },
  });
  const dateAnimation = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    delay: 2800,
    config: { tension: 40, friction: 30 },
  });
  const AnimatedDiv = animated.div as React.FC<
    AnimatedProps<React.HTMLAttributes<HTMLDivElement>>
  >;

  return (
    <Parallax
      bgImage={backgroundImage}
      strength={500}
      bgImageStyle={{ objectFit: 'cover', top: '-30%' }}
      className="relative h-screen bg-center text-white uppercase"
    >
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 sm:px-6 md:px-8 py-8">
        <div className="h-screen">
          <AnimatedDiv style={titleAnimation}>
            <p className="text-[13px] font-bold tracking-[0.55em] uppercase md:mt-8">
              Nuestra Boda
            </p>
            <h1 className="font-cormorant text-5xl tracking-[0.15em] mt-4">
              GETSEMANI Y RODRIGO
            </h1>
          </AnimatedDiv>
          {/* Separator */}
          <AnimatedDiv style={subtitleAnimation} className="mt-4">
            <div className="mt-4">
              <img
                src={ornament}
                alt="Ornament"
                className="mx-auto transform scale-x-[1] ornament-size h-auto "
              />
            </div>
          </AnimatedDiv>
          <AnimatedDiv style={dateAnimation} className="mt-4">
            <div className="mt-3">
              <p className="mt-3 text-sm uppercase tracking-[0.3em]">
                San Miguel de Allende, Guanajuato
              </p>
            </div>
          </AnimatedDiv>
        </div>
      </div>
    </Parallax>
  );
};

export default HeroSection;
